import { DPApps } from "./apps.types";

export const AppToInitialize: string = DPApps.mrm || process.env.VITE_REACT_APP_MODULE || (DPApps.mrm as string);
export const isP2Module = AppToInitialize === DPApps.p2; //
